export default {
  title: 'Nu ratați!',
  description: 'Activați notificările pentru a fi la curent cu comanda dvs.',
  buttons: {
    enable: 'Activați',
  },
};
